/* IAC types */
export const TYPES = {
  USECASE: 1 << 0,
  EVENT: 1 << 1,
  RPC: 1 << 2,
  RPE: 1 << 3,
  INTERN: 1 << 4,
  EXTERN: 1 << 5,
  SPLASH: 1 << 6,
};

/* IAC event types */
export const IAC_EVENT_TYPES = {
  ONSTART: 'onstart',
  ONCLOSE: 'onclose',
  ONFOCUS: 'onfocus',
  ONRESUMEFOCUS: 'onresumefocus',
  ONBLUR: 'onblur',
  ONRESTART: 'onrestart',
  ONENABLED: 'onenabled',
  ONDISABLED: 'ondisabled',
};

/* EventHandler Constants */
export const EVENT_HANDLER_TYPES = {
  CONNECTIVITY_ONLINE: 'CONNECTIVITY_ONLINE',
  CONNECTIVITY_OFFLINE: 'CONNECTIVITY_OFFLINE',
  SCRIPT_INTERRUPTION: 'SCRIPT_INTERRUPTION',
  KEEPALIVE_FAILED: 'KEEPALIVE_FAILED',
  KEEPALIVE_SUCCEEDED: 'KEEPALIVE_SUCCEEDED',
};

/* Application types */
export const APP_TYPES = {
  FULLSCREEN: 'fullscreen',
  DIALOG: 'dialog',
};
